export const getTimeFromDate: (date: Date) => string = (date) => {
  const hours: string = `${date.getHours()}`;
  const minutes: string = `${date.getMinutes()}`;

  return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
};
